export enum AcceptEnum {
  JPG = 'image/jpeg',
  PNG = 'image/png',
  SVG = 'image/svg+xml',
  PDF = 'application/pdf',
}
